<template>
    <div>
        <!--<el-form label-width="70px" :label-position="'right'">-->
        <!--<el-row :gutter="10">-->
        <!--<el-form-item label="分期比例">-->
        <!--<el-select v-model="$parentInfo.studentCart.dialog_Installment.proportion" placeholder="请选择分期比例">-->
        <!--<el-option-->
        <!--v-for="item in filter"-->
        <!--:key="item.id"-->
        <!--:label="item.name"-->
        <!--:value="item.id">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
        <!--</el-row>-->
        <!--</el-form>-->
        <el-form label-width="50px">
            <el-form-item label="首付">
                <el-input v-model="$parentInfo.studentCart.dialog_Installment.proportion"
                          size="medium"
                          placeholder="请输入首付金额"></el-input>
            </el-form-item>
        </el-form>
        <div class="text-right">
            <el-button type="primary" size="small" @click="handleChangeInstallment()"
                       :loading="$parentInfo.studentCart.dialog_Installment.button_loading">确 定
            </el-button>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                parentInfo: '',
                filter: [
                    {'id': 0.4, 'name': '40%'},
                    {'id': 0.5, 'name': '50%'},
                    {'id': 0.6, 'name': '60%'},
                    {'id': 0.7, 'name': '70%'},
                    {'id': 0.8, 'name': '80%'},
                    {'id': 0.9, 'name': '90%'},
                ],
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentCart.dialog_Installment.proportion = '';
        },
        methods: {
            // 修改
            handleChangeInstallment() {
                this.$parentInfo.studentCart.dialog_Installment.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'changeInstallment', {
                    'proportion': this.$parentInfo.studentCart.dialog_Installment.proportion,
                    'selections': this.$store.state.modal.data.selections,
                    'sumPay': this.$store.state.modal.data.sumPay,
                    'student_id': this.$parentInfo.student_id,
                });
            },
        }
    };
</script>

<style scoped>
</style>
